<template>
  <div>
    <br />
    <br />
    <br />
    <br />
    <br />
    <el-row :gutter="1">
      <el-col :span="12">
        <div>
          <el-button type="primary" plain  style="width:450px;" @click="jump('/taxBook')">{{"源泉徴収簿"}}</el-button>
        </div>
      </el-col>
      <el-col :span="12">
        <div>
          <el-button type="primary" plain style="width:450px;" @click="jump('/taxForm')">{{"給与所得の源泉徴収票"}}</el-button>
        </div>
      </el-col>

    </el-row>
    <br />

    <el-row :gutter="1">
      <el-col :span="12">
        <div>
          <el-button type="primary" plain style="width:450px;" @click="jump('/HealthIns4')">{{$t('router.health.HealthIns4')}}</el-button>
        </div>
      </el-col>

      <el-col :span="12">
        <div>
          <el-button type="primary" plain style="width:450px;" @click="jump('/HealthIns3')">{{$t('router.health.HealthIns3')}}</el-button>
        </div>
      </el-col>
    </el-row>

    <br />

    <el-row :gutter="1">
      <el-col :span="12">
        <div>
          <el-button type="primary" plain style="width:450px;" @click="jump('/HealthIns5')">{{$t('router.health.HealthIns5')}}</el-button>
        </div>
      </el-col>
      <el-col :span="12">
        <div>
          <el-button type="primary" plain style="width:450px;" @click="jump('/SuspensionNotice')">{{$t('router.health.SuspensionNotice')}}</el-button>
        </div>
      </el-col>
    </el-row>

    <br />
    <el-row :gutter="1">
      <el-col :span="12">
        <div>
          <el-button type="primary" plain style="width:450px;" @click="jump('/InsNameChange')">{{$t('router.health.InsNameChange')}}</el-button>
        </div>
      </el-col>
      <el-col :span="12">
        <div>
          <el-button type="primary" plain style="width:450px;" @click="jump('/InsDisqualifyNotice')">{{$t('router.health.InsDisqualifyNotice')}}</el-button>
        </div>
      </el-col>

    </el-row>

    <br />
    <el-row :gutter="1">
      <el-col :span="12">
        <div>
          <el-button type="primary" plain style="width:450px;" @click="jump('/InsQualifyNotice')">{{$t('router.health.InsQualifyNotice')}}</el-button>
        </div>
      </el-col>

      <el-col :span="12">
        <div>
          <el-button type="primary" plain style="width:450px;" @click="jump('/PensionReissue')">{{$t('router.social.pension_reissue')}}</el-button>
        </div>
      </el-col>
    </el-row>
    <br />

    <el-row :gutter="1">
      <el-col :span="12">
        <div>
          <el-button type="primary" plain style="width:450px;" @click="jump('/AttoneryPower')">{{$t('router.social.attorney_power')}}</el-button>
        </div>
      </el-col>
      <el-col :span="12">
        <div>
          <el-button style="width:450px;" icon="fa fa-reply" @click="jump('/homePage')" 　type="primary" 　plain>&nbsp;ホームページに戻る</el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    jump(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
}

.el-col {
  border-radius: 4px;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>


// WEBPACK FOOTER //
// src/components/EndYearAdj/EndYearAdjHome.vue